import plateSizeOptions from "./plateSizeOptions";

class GoldPrizeCalculator {
    constructor() {
        let smallPlate = plateSizeOptions.getPlate("medium");
        this.pWidth = smallPlate.width; // in mm
        this.pHeight = smallPlate.height; // in mm
        this.pThickness = 1.02; // in mm (converted to cm)
        this.pDensity = 12.9; // in g/cm^3
        this.multiplier = 1;
        this.buildData();
    }
    updateData({ pWidth, pHeight, pThickness, pDensity }) {
        this.pWidth = pWidth || this.pWidth;
        this.pHeight = pHeight || this.pHeight;
        this.pThickness = pThickness || this.pThickness;
        this.pDensity = pDensity || this.pDensity;
        this.buildData();
    }

    buildData() {
        this.pWidth *= this.multiplier;
        this.pHeight *= this.multiplier;
        this.pArea = this.pWidth * this.pHeight;
    }
    setPThickness(inThickness) {
        this.pThickness = inThickness / this.multiplier;
        this.buildData();
    }
    getPArea() {
        return this.pArea;
    }
    getRawWeight() {
        let actualArea = this.pArea / this.multiplier / this.multiplier;
        let volume = actualArea * this.pThickness;
        volume /= 1000; // convert volume from mm^3 to cm^3
        let weight = volume * this.pDensity;
        return weight;
    }
    getWeightFromSurfaceArea(surfaceArea) {
        let actualArea = surfaceArea / this.multiplier / this.multiplier;
        let volume = actualArea * this.pThickness;
        volume /= 1000; // convert volume from mm^3 to cm^3
        let weight = volume * this.pDensity;
        return weight;
    }
    addExtraWeight(weight, plateSize, deviationData = null) {
        if (plateSize === "small") {
            weight += deviationData?.smallDeviation;
        } else if (plateSize === "medium") {
            weight += deviationData?.mediumDeviation;
        } else if (plateSize === "large") {
            weight += deviationData?.largeDeviation;
        }
        return weight;
    }
    getPWidth() {
        return this.pWidth;
    }
    getPHeight() {
        return this.pHeight;
    }
    getPDensity() {
        return this.pDensity;
    }
    getThickness() {
        return this.pThickness;
    }
}
const goldPrizeCalculator = new GoldPrizeCalculator();
export default goldPrizeCalculator;
